import { socialLinks } from "@/lib/social-links";

export function SocialLinks() {
  return (
    <nav aria-label="Cooperly social media">
      <ul className="flex flex-wrap gap-x-4 text-sm leading-6">
        {socialLinks.map((link) => (
          <li key={link.label}>
            <a
              href={link.href}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex min-h-11 items-center text-muted-foreground underline underline-offset-4 transition-colors hover:text-foreground focus-visible:rounded-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-4"
            >
              {link.label}
            </a>
          </li>
        ))}
      </ul>
    </nav>
  );
}
